import TYPES from './types';

export const listeningFromSocket = (service, data) => ({
  data,
  service,
  type: TYPES.LISTENING_FROM_SOCKET_DATA,
});
